var g1 = "/static/8851e4aec7bc1b15.png";

export { g1 as default };
//# sourceMappingURL=g_1.png.js.map
